import React from 'react';
import { useTranslation } from 'react-i18next';

const Purchases = () => {
  const {t} = useTranslation()
  return (
    <div>
      {t('Purchases')}
    </div>
  );
};

export default Purchases;